import type { Delivery } from '@citibox-panel/api-client';
import { DELIVERY_STATES } from '../../../lib/deliveryStates';

// The pickup date renders by status, not by presence: a Customer Care restore keeps
// collected_date, so a re-opened parcel is «En el buzón» with a stale pickup date. Return
// it only while the delivery is actually collected, else null (the row and the copy both
// show an em dash) — so a re-opened parcel never looks collected on screen or in a ticket.
export function displayedPickupDate(delivery: Delivery): string | null {
  return delivery.status.toLowerCase() === DELIVERY_STATES.collected ? delivery.collectedDate : null;
}
